import { Divider } from "@mui/joy";
import { IntencionesVendedor } from "../../../../types/visitas";

interface Props {
    intenciones: IntencionesVendedor[];
}

export function IntencionesVendidas({ intenciones }: Props) {

    return (
        <div className="flex flex-col flex-1 overflow-hidden">
            <Divider>
                <p className="text-sm font-semibold h-[30px]">Intenciones vendidas</p>
            </Divider>

            <div className="mt-2 flex flex-col overflow-auto flex-1">
                {intenciones.length === 0
                ? <p className="text-sm font-semibold text-gray-600 italic text-center">No hay intenciones agregadas</p>
                : 
                <>
                {intenciones.map((intencion, index) => (
                    <div 
                        key={index}
                        className="flex gap-x-2 justify-between hover:bg-slate-50 p-2 rounded-md">
                        <div className="flex gap-x-1">
                            <div className="w-[20px] h-[20px] bg-gray-500 rounded-full"></div>
                            <p className="text-sm font-semibold">{intencion.nombreVendedor}</p>
                        </div>
                        <div>
                            <p className="text-sm font-semibold">Intenciones vendidas: {intencion.intenciones}</p>
                        </div>
                    </div>
                ))}
                </>
                }
            </div>

        </div>
    );
}
